import React, { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";

export default function CustomLiveInvoiceModal({ isOpen, onClose, onGenerated }) {
  const [students, setStudents] = useState([]);
  const [form, setForm] = useState({ student_id: "", start_date: "", end_date: "" });

  useEffect(() => {
    if (!isOpen) return;
    setForm({ student_id: "", start_date: "", end_date: "" });

    axios
      .get(`${process.env.REACT_APP_API_URL}/admin/getStudent`)
      .then((response) => {
        if (response.data.success) {
          setStudents(
            response.data.data.map((s) => ({
              value: s.student_id,
              label: `${s.surname || ""} ${s.first_name || ""} (${s.student_id})`.trim(),
            }))
          );
        } else {
          console.error("Failed to fetch students:", response.data.message);
          alert("Failed to load students. Please try again.");
          setStudents([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching students:", err);
        alert("Error loading students. Please check your connection.");
        setStudents([]);
      });
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.student_id || !form.start_date || !form.end_date) {
      alert("Please fill in all fields.");
      return;
    }

    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/admin/custom/invoice`, {
        student_id: form.student_id,
        start_date: form.start_date,
        end_date: form.end_date,
      });

      if (res.data.success) {
        alert(`Invoice generated successfully: ${res.data.message}`);
        onClose();
        if (onGenerated) onGenerated(form.end_date);
      } else {
        console.error("Failed to generate custom invoice:", res.data.error);
        alert(`Failed to generate invoice: ${res.data.error || "Unknown error"}`);
      }
    } catch (err) {
      console.error("Error generating custom invoice:", err);
      alert(err.response?.data?.error || "Error generating custom invoice.");
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg w-1/2">
        <h3 className="text-xl font-semibold mb-4">Customize Live Invoice</h3>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-gray-700 mb-1">Student:</label>
            <Select
              options={students}
              onChange={(selected) =>
                setForm({ ...form, student_id: selected ? selected.value : "" })
              }
              placeholder="Search for a student..."
              isClearable
              className="w-full"
              classNamePrefix="react-select"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 mb-1">Start Date:</label>
            <input
              type="date"
              value={form.start_date}
              onChange={(e) => setForm({ ...form, start_date: e.target.value })}
              className="w-full border p-2 rounded"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 mb-1">End Date:</label>
            <input
              type="date"
              value={form.end_date}
              onChange={(e) => setForm({ ...form, end_date: e.target.value })}
              className="w-full border p-2 rounded"
            />
          </div>
          <div className="flex justify-end">
            <button
              type="button"
              onClick={onClose}
              className="bg-gray-500 text-white px-4 py-2 mr-2 rounded hover:bg-gray-600"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
            >
              Generate
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
